import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jsmWorkItemEmbedRoute: InvariantJiraRoute = {
	name: 'jsm-work-item-embed',
	path: '/browse/jsm-work-item/:issueKey(\\w+-\\d+)/embed',
};
